import React from 'react'
import { createIconComponent } from '../Icon'

const OutlinedLarge = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/></svg>
)

const OutlinedSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20"><path d="M576-253.847 349.847-480 576-706.153 613.153-669l-189 189 189 189L576-253.847Z"/></svg>
)

const FilledLarge = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/></svg>
)

const FilledSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20"><path d="M576-253.847 349.847-480 576-706.153 613.153-669l-189 189 189 189L576-253.847Z"/></svg>
)

export const ChevronLeftIcon = createIconComponent({
  OutlinedLarge,
  OutlinedSmall,
  FilledLarge,
  FilledSmall,
})
